/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Mode_Hint_RtpInputs */



/**
* | output |
* | --- |
* | "VEKN rating points from every league event, added up. No best-8 or 18-month limit here." |
*
* @param {League_Mode_Hint_RtpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_mode_hint_rtp = /** @type {((inputs?: League_Mode_Hint_RtpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Mode_Hint_RtpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de rating VEKN de chaque tournoi de la ligue, additionnés. Pas de limite des 8 meilleurs ni des 18 mois ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de rating VEKN de cada torneo de la liga, sumados. Aquí no hay límite de 8 mejores ni de 18 meses.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de classificação VEKN de cada torneio da liga, somados. Aqui não há limite de 8 melhores nem de 18 meses.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punti rating VEKN di ogni torneo del campionato, sommati. Qui niente limite degli 8 migliori né dei 18 mesi.")
	return /** @type {LocalizedString} */ ("VEKN rating points from every league event, added up. No best-8 or 18-month limit here.")
});